"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceList = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var mapStateToProps = function (state) { return state; };
var mapDispatchToProps = function () { return ({}); };
exports.priceList = function (props) {
    var priceListHeadStyle = {
        zIndex: 2,
        backgroundColor: '#fff',
        position: 'relative',
    };
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { id: "price-list", className: "t--darker" },
            React.createElement("div", { className: "l-container l-container--lr u-mobile-hidden l-pad-top l-pad--2 t--darker" },
                React.createElement(Breadcrumb_1.default, null)),
            React.createElement("div", { style: priceListHeadStyle },
                React.createElement("div", { className: "c-jumbo c-jumbo--thin c-jumbo--lift", style: { marginBottom: 0 } },
                    React.createElement("div", { className: "l-container l-container--rfull" },
                        React.createElement("div", { className: "l-container__main" },
                            React.createElement("h1", { className: "o-h1 o-h1--no-mb" }, "The Mediterranean"))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.priceList);
